import React from 'react';

const SlAppStars = () => (
  <svg width="76px" height="12px" viewBox="0 0 76 12">
    <g id="Mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-72.000000, -619.000000)" fill="#0058B0" fillRule="nonzero">
        <g transform="translate(0.000000, 569.000000)">
          <g transform="translate(16.000000, 24.000000)">
            <g transform="translate(56.000000, 26.000000)">
              <polygon points="8.70012068 7.56491407 12 4.53236301 7.6534277 4.13684888 6 0 4.3465723 4.13684888 0 4.53236301 3.29987932 7.56491407 2.32711633 12 6 9.6509227 9.67288367 12" />
              <polygon points="24.7001207 7.56491407 28 4.53236301 23.6534277 4.13684888 22 0 20.3465723 4.13684888 16 4.53236301 19.2998793 7.56491407 18.3271163 12 22 9.6509227 25.6728837 12" />
              <polygon points="40.7001207 7.56491407 44 4.53236301 39.6534277 4.13684888 38 0 36.3465723 4.13684888 32 4.53236301 35.2998793 7.56491407 34.3271163 12 38 9.6509227 41.6728837 12" />
              <polygon points="56.7001207 7.56491407 60 4.53236301 55.6534277 4.13684888 54 0 52.3465723 4.13684888 48 4.53236301 51.2998793 7.56491407 50.3271163 12 54 9.6509227 57.6728837 12" />
              <polygon points="72.7001207 7.56491407 76 4.53236301 71.6534277 4.13684888 70 0 68.3465723 4.13684888 64 4.53236301 67.2998793 7.56491407 66.3271163 12 70 9.6509227 73.6728837 12" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default SlAppStars;
